<template>
  <el-popover
    v-model="open"
    placement="bottom-end"
    trigger="click"
    :width="420"
    popper-class="sai-wallet-popover">
    <iframe
      v-if="loaded"
      id="app-ai-wallet-frame"
      title="Quản lí sử dụng AI"
      :src="iframeSrc"
      class="sai-wallet-frame"
    ></iframe>
    <el-button
      slot="reference"
      size="small"
      icon="el-icon-wallet">
      Quản lí sử dụng AI
    </el-button>
  </el-popover>
</template>

<script>
const WALLET_IFRAME_BASE = 'https://ai.salework.net/';

export default {
  name: 'SaleAIWalletDialog',

  data() {
    return {
      open: false,
      // Lazy-load iframe on first open; keep mounted after so it doesn't re-fetch on each toggle
      loaded: false,
    };
  },

  computed: {
    iframeSrc() {
      const companyCode = (this.app && this.app.user && this.app.user.companyCode) || '';
      return companyCode
        ? WALLET_IFRAME_BASE + '/apps'
        : WALLET_IFRAME_BASE;
    },
  },

  watch: {
    open(v) { if (v) this.loaded = true; },
  },
};
</script>

<style>
/* popper-class is appended to body, so no .sai-app prefix */
.sai-wallet-popover {
  padding: 0 !important;
  border-radius: 14px !important;
  overflow: hidden !important;
  border: 1px solid rgba(15, 23, 42, 0.08) !important;
  box-shadow: 0 12px 32px -8px rgba(15, 23, 42, 0.18) !important;
}
.sai-wallet-popover .popper__arrow,
.sai-wallet-popover .popper__arrow::after { display: none !important; }
.sai-wallet-frame {
  display: block;
  width: 420px;
  height: 600px;
  border: 0;
  background: #fff;
}
</style>
